export default __webpack_public_path__ + "static/media/ic_application_android.94b9ed6a.svg";